import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import TableHeader from "../../../../components/Tables/TableHeader";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function TableOfViewSchoolEvents({ sortedEvents, handleHeaderClick }) {
  const { logout } = StaffuseAuth();

  const SchoolEventsFieldsArray = [
    { Name: "Name", Field: "School_Name" },
    { Name: "Staff", Field: "pd" },
    { Name: "Type", Field: "Type_of_Event" },
    { Name: "Contact", Field: "Lead_Contact_Name" },
    { Name: "Heat", Field: "Heat" },
    { Name: "TCS", Field: "Careers_School_Proposal" },
    { Name: "Date", Field: "Date" },
    { Name: "Notes", Field: "Notes" },
    { Name: "Overtime", Field: "Overtime" },
  ];

  //-----------------------------Return---------------------------------------------

  return (
    <Table
      aria-label="simple table"
      sx={{
        border: "1px solid #e0e0e0",
        tableLayout: "fixed",
      }}
    >
      <TableHead>
        <TableRow>
          {SchoolEventsFieldsArray.map((prop) => {
            return <>{TableHeader(prop.Name, handleHeaderClick, prop.Field)}</>;
          })}
          <>{TableHeader("Update", handleHeaderClick, "School_Name")}</>
        </TableRow>
      </TableHead>
      <TableBody>
        {sortedEvents.map((Event, index) => (
          <TableRow
            key={index}
            sx={{
              "&:hover": {
                backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                "& .MuiTableCell-root": {
                  padding: "8px",
                  wordWrap: "break-word",
                  overflowWrap: "break-word", // Adjust padding here to make cells smaller
                },
              },
              tableLayout: "fixed",
            }}
          >
            <TableCell
              component="th"
              scope="row"
              sx={{
                padding: "8px",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {Event.School_Name}
            </TableCell>
            <TableCell
              component="th"
              scope="row"
              sx={{
                padding: "8px",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {Event.pd}
            </TableCell>
            <TableCell
              component="th"
              scope="row"
              sx={{
                padding: "8px",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {Event.Type_of_Event}
            </TableCell>
            <TableCell
              component="th"
              scope="row"
              sx={{
                padding: "8px",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {Event.Lead_Contact_Name}
            </TableCell>
            <TableCell
              component="th"
              scope="row"
              sx={{
                padding: "8px",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {Event.Heat}
            </TableCell>
            <TableCell
              component="th"
              scope="row"
              sx={{
                padding: "8px",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {Event.Careers_School_Proposal}
            </TableCell>
            <TableCell
              component="th"
              scope="row"
              sx={{
                padding: "8px",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {Event.Date}
            </TableCell>
            <TableCell align="left">
              <Tooltip title={Event.Notes} placement="top" arrow>
                <IconButton>
                  <InfoIcon />
                </IconButton>
              </Tooltip>
            </TableCell>
            <TableCell
              component="th"
              scope="row"
              sx={{
                padding: "8px",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {Event.Overtime}
            </TableCell>

            {/* New TableCell for update action using Link */}
            <TableCell
              align="left"
              sx={{
                padding: "8px",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              <Link
                to={`/UpdateSchoolEvent/${Event._id}`}
                target="_blank"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <button>Update</button>
              </Link>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default TableOfViewSchoolEvents;
